import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Row, Col, Container } from 'react-bootstrap'
import img70 from '../EquipoMedico/img70.jpg'

export class Intensive extends Component {
    render() {
        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Intensive Care</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Centramos la Card para que la información densa del equipo 
                        de cuidados intensivos se aprecie con total claridad */}
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8}>
                            <Card className="shadow border-0 text-center">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img70} 
                                        style={{ 
                                            width: '100%', 
                                            height: 'auto', 
                                            maxHeight: '900px', 
                                            objectFit: 'contain' 
                                        }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.8rem', padding: '10px' }}>
                                        Intensive Care Unit (ICU) Equipment
                                    </Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}